import Papa from 'papaparse';

/**
 * @function csvToJson
 * @description Convertie un fichier csv au format json avec la library
 * papaparse voir {@link https://www.papaparse.com/docs}.
 *
 * @param {blob} file - Fichier text contenant le csv uploader
 * @param {boolean} header - indique si le fichier contient un header
 * @returns {object} Fichier transformé en object javascript
 */
const csvToJson = (file, header) => {
  const config = {
    skipEmptyLines: true,
    header,
    encoding: 'ISO-8859-1'
  };
  return Papa.parse(file, config).data;
};

export default csvToJson;
